<template>
  <div name="demo">
    <template v-if="menuDisp">
      <div class="col-md-12">
        <label class="color-skin"><a @click="toggle({main: '', descMain: ''}, {type: '', descSub: ''})">{{title}}</a></label>
      </div>
      <div class="col-md-6">
        <div class="row">
          <div class="form-group">
            <ul v-for="topic in topicFilter(topics, 'done')">
              <li>{{topic.descMain}}</li>
              <ul v-for="sub in subFilter(topic.sub, 'done')">
                <li>
                  <a  @click="togglePage(topic, sub)"
                      :class="{ 'text-black' : (main == topic.main && type == sub.type) }" 
                      class="cursor-pointer">
                    {{sub.status}} - {{sub.type}}
                  </a>
                </li>
              </ul>
            </ul>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="row">
          <div class="form-group">
            <ul v-for="topic in topicFilter(topics, 'coding')">
              <li>{{topic.descMain}}</li>
              <ul v-for="sub in subFilter(topic.sub, 'coding')">
                <li>
                  <a  @click="togglePage(topic, sub)"
                      :class="{ 'text-black' : (main == topic.main && type == sub.type) }"
                      class="cursor-pointer">
                    {{sub.status}} - {{sub.type}}
                  </a>
                </li>
              </ul>
            </ul>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="col-md-12">
        <label class="color-skin align-center">{{descMain}} - {{descSub}}</label>
        <div class="form-group-button">
          <div class="btn button-in-search bg-red" @click="toggleMenu()"><i class="fa fa-rotate-left"></i>Back</div>
        </div>
        <template v-if="main == 'table'">
          <demo-table-sort              v-if="type == 'sort'" />
          <demo-table-request           v-if="type == 'request'" />
          <demo-table-approve-all       v-if="type == 'approveAll'" />
          <demo-table-approve-row       v-if="type == 'approveRow'" />
          <demo-table-inline-add        v-if="type == 'addInline'" />
          <demo-table-inline-edit       v-if="type == 'editInline'" />
          <demo-table-inline-delete     v-if="type == 'deleteInline'" />
          <demo-table-inline-validate   v-if="type == 'validateInline'" />
          <demo-table-inline            v-if="type == 'inline'" />
          <demo-table-display           v-if="type == 'display'" />
          <demo-table-row-condition-request v-if="type == 'rowconditionRequest'" />
          <demo-table-row-condition-inline  v-if="type == 'rowconditionInline'" />
          <demo-table-row-condition-approve v-if="type == 'rowconditionApprove'" />
          <demo-table-row-column-style      v-if="type == 'rowcolumnstyle'" />
        </template>
        <template v-else-if="main == 'searchbox'">
          <demo-searchbox-box-type      v-if="type == 'boxType'" />
          <demo-searchbox-rules         v-if="type == 'rules'" />
          <demo-searchbox-condition     v-if="type == 'condition'" />
          <demo-searchbox-codcomp       v-if="type == 'codcomp'" />
          <demo-searchbox-codempid      v-if="type == 'codempid'" />
          <demo-searchbox-codpos        v-if="type == 'codpos'" />
          <demo-searchbox-codapp        v-if="type == 'codapp'" />
        </template>
        <template v-else-if="main == 'validate'">
          <demo-validate-required             v-if="type == 'required'" />
          <demo-validate-date-format          v-if="type == 'dateFormat'" />
          <demo-validate-larger-than          v-if="type == 'largerThan'" />
          <demo-validate-required-when-exist  v-if="type == 'requiredWhenExist'" />
          <demo-validate-required-any         v-if="type == 'requiredAny'" />
          <demo-validate-required-all-when-exist-all      v-if="type == 'requiredAllWhenExistAll'" />
          <demo-validate-required-all-when-exist-any      v-if="type == 'requiredAllWhenExistAny'" />
          <demo-validate-required-all-when-not-exist-all  v-if="type == 'requiredAllWhenNotExistAll'" />
          <demo-validate-required-all-when-not-exist-any  v-if="type == 'requiredAllWhenNotExistAny'" />
          <demo-validate-required-any-when-exist-all      v-if="type == 'requiredAnyWhenExistAll'" />
          <demo-validate-required-any-when-exist-any      v-if="type == 'requiredAnyWhenExistAny'" />
          <demo-validate-required-any-when-not-exist-all  v-if="type == 'requiredAnyWhenNotExistAll'" />
          <demo-validate-required-any-when-not-exist-any  v-if="type == 'requiredAnyWhenNotExistAny'" />
          <demo-validate-validate-all         v-if="type == 'validateAll'" />
        </template>
        <template v-else-if="main == 'pdf'">
          <demo-pdf-report-html     v-if="type == 'html'" />
          <demo-pdf-report-text     v-if="type == 'text'" />
          <demo-pdf-report-password v-if="type == 'password'" />
        </template>
        <template v-else-if="main == 'export'">
          <demo-export-html     v-if="type == 'html'" />
          <demo-export-text     v-if="type == 'text'" />
          <demo-export-excel    v-if="type == 'excel'" />
        </template>
        <template v-else-if="main == 'import'">
          <demo-import-csv      v-if="type == 'csv'" />
          <demo-import-text     v-if="type == 'text'" />
          <demo-import-excel    v-if="type == 'excel'" />
        </template>
        <template v-else-if="main == 'calendar'">
          <demo-calendar-worktime v-if="type == 'worktime'" />
        </template>
        <template v-else-if="main == 'upload'">
          <demo-upload-single     v-if="type == 'single'" />
          <demo-upload-single     v-if="type == 'multi'" />
          <demo-upload-image      v-if="type == 'image'" />
          <demo-upload-file       v-if="type == 'file'" />
          <demo-upload-file       v-if="type == 'limit'" />
        </template>
        <template v-else-if="main == 'logicalstatement'">
          <demo-logical-statement v-if="type == 'add'" />
        </template>
        <template v-else-if="main == 'orgchart'">
          <demo-orgchart-js       v-if="type == 'orgchartJs'" />
        </template>
        <template v-else-if="main == 'chart'">
          <demo-chart-line        v-if="type == 'line'" />
          <demo-chart-bar         v-if="type == 'bar'" />
          <demo-chart-pie         v-if="type == 'pie'" />
          <demo-chart-bubble      v-if="type == 'bubble'" />
          <demo-chart-radar       v-if="type == 'radar'" />
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import demoTableSort from 'components/demo/demoTableSort'
import demoTableRequest from 'components/demo/demoTableRequest'
import demoTableApproveAll from 'components/demo/demoTableApproveAll'
import demoTableApproveRow from 'components/demo/demoTableApproveRow'
import demoTableInlineAdd from 'components/demo/demoTableInlineAdd'
import demoTableInlineEdit from 'components/demo/demoTableInlineEdit'
import demoTableInlineDelete from 'components/demo/demoTableInlineDelete'
import demoTableInlineValidate from 'components/demo/demoTableInlineValidate'
import demoTableInline from 'components/demo/demoTableInline'
import demoTableDisplay from 'components/demo/demoTableDisplay'
import demoTableRowConditionRequest from 'components/demo/demoTableRowConditionRequest'
import demoTableRowConditionInline from 'components/demo/demoTableRowConditionInline'
import demoTableRowConditionApprove from 'components/demo/demoTableRowConditionApprove'
import demoTableRowColumnStyle from 'components/demo/demoTableRowColumnStyle'
import demoSearchboxBoxType from 'components/demo/demoSearchboxBoxType'
import demoSearchboxRules from 'components/demo/demoSearchboxRules'
import demoSearchboxCondition from 'components/demo/demoSearchboxCondition'
import demoSearchboxCodcomp from 'components/demo/demoSearchboxCodcomp'
import demoSearchboxCodempid from 'components/demo/demoSearchboxCodempid'
import demoSearchboxCodpos from 'components/demo/demoSearchboxCodpos'
import demoSearchboxCodapp from 'components/demo/demoSearchboxCodapp'
import demoValidateRequired from 'components/demo/demoValidateRequired'
import demoValidateDateFormat from 'components/demo/demoValidateDateFormat'
import demoValidateLargerThan from 'components/demo/demoValidateLargerThan'
import demoValidateRequiredWhenExist from 'components/demo/demoValidateRequiredWhenExist'
import demoValidateRequiredAny from 'components/demo/demoValidateRequiredAny'
import demoValidateRequiredAllWhenExistAll from 'components/demo/demoValidateRequiredAllWhenExistAll'
import demoValidateRequiredAllWhenExistAny from 'components/demo/demoValidateRequiredAllWhenExistAny'
import demoValidateRequiredAllWhenNotExistAll from 'components/demo/demoValidateRequiredAllWhenNotExistAll'
import demoValidateRequiredAllWhenNotExistAny from 'components/demo/demoValidateRequiredAllWhenNotExistAny'
import demoValidateRequiredAnyWhenExistAll from 'components/demo/demoValidateRequiredAnyWhenExistAll'
import demoValidateRequiredAnyWhenExistAny from 'components/demo/demoValidateRequiredAnyWhenExistAny'
import demoValidateRequiredAnyWhenNotExistAll from 'components/demo/demoValidateRequiredAnyWhenNotExistAll'
import demoValidateRequiredAnyWhenNotExistAny from 'components/demo/demoValidateRequiredAnyWhenNotExistAny'
import demoValidateValidateAll from 'components/demo/demoValidateValidateAll'
import demoCalendarWorktime from 'components/demo/demoCalendarWorktime'
import demoUploadSingle from 'components/demo/demoUploadSingle'
import demoUploadImage from 'components/demo/demoUploadImage'
import demoUploadFile from 'components/demo/demoUploadFile'
import demoPdfReportHtml from 'components/demo/demoPdfReportHtml'
import demoPdfReportText from 'components/demo/demoPdfReportText'
import demoPdfReportPassword from 'components/demo/demoPdfReportPassword'
import demoExportHtml from 'components/demo/demoExportHtml'
import demoExportText from 'components/demo/demoExportText'
import demoExportExcel from 'components/demo/demoExportExcel'
import demoImportCsv from 'components/demo/demoImportCsv'
import demoImportText from 'components/demo/demoImportText'
import demoImportExcel from 'components/demo/demoImportExcel'
import demoLogicalStatement from 'components/demo/demoLogicalStatement'
import demoOrgchartJs from 'components/demo/demoOrgchartJs'
import demoChartLine from 'components/demo/demoChartLine'
import demoChartBar from 'components/demo/demoChartBar.js'
import demoChartPie from 'components/demo/demoChartPie'
import demoChartBubble from 'components/demo/demoChartBubble'
import demoChartRadar from 'components/demo/demoChartRadar'

export default {
  name: 'demo',
  data () {
    return {
      menuDisp: true,
      main: '',
      type: '',
      descMain: '',
      descSub: '',
      title: 'HRMS Standard Demo',
      topics: [{
        main: 'table',
        descMain: 'Table Generator',
        sub: [{
          type: 'sort',
          descSub: 'Sort Target Column by String, Number, and Date',
          status: 'done'
        }, {
          type: 'request',
          descSub: 'Request',
          status: 'done'
        }, {
          type: 'approveAll',
          descSub: 'Approve All',
          status: 'done'
        }, {
          type: 'approveRow',
          descSub: 'Approve Row',
          status: 'done'
        }, {
          type: 'addInline',
          descSub: 'Add Inline',
          status: 'done'
        }, {
          type: 'editInline',
          descSub: 'Edit Inline',
          status: 'done'
        }, {
          type: 'deleteInline',
          descSub: 'Delete Inline',
          status: 'done'
        }, {
          type: 'validateInline',
          descSub: 'Validate Inline',
          status: 'done'
        }, {
          type: 'inline',
          descSub: 'Full Inline',
          status: 'done'
        }, {
          type: 'display',
          descSub: 'Display',
          status: 'done'
        }, {
          type: 'rowconditionRequest',
          descSub: 'Specific Event for each Row in Request Tablee',
          status: 'done'
        }, {
          type: 'rowconditionApprove',
          descSub: 'Specific Event for each Row in Approve Table',
          status: 'done'
        }, {
          type: 'rowconditionInline',
          descSub: 'Specific Event for each Row in Inline Table',
          status: 'done'
        }, {
          type: 'rowcolumnstyle',
          descSub: 'Specific Style for each Row-Column',
          status: 'coding'
        }]
      }, {
        main: 'searchbox',
        descMain: 'Searchbox Generator',
        sub: [{
          type: 'boxType',
          descSub: 'Generate Searchbox Components',
          status: 'done'
        }, {
          type: 'rules',
          descSub: 'Generate Validation on Searchbox Components',
          status: 'done'
        }, {
          type: 'condition',
          descSub: 'Generate Event Condition on Searchbox Components',
          status: 'coding'
        }, {
          type: 'codcomp',
          descSub: 'Generate Searchbox Codcomp',
          status: 'done'
        }, {
          type: 'codempid',
          descSub: 'Generate Searchbox Codempid',
          status: 'done'
        }, {
          type: 'codpos',
          descSub: 'Generate Searchbox Codpos',
          status: 'done'
        }, {
          type: 'codapp',
          descSub: 'Generate Searchbox Codapp',
          status: 'done'
        }]
      }, {
        main: 'validate',
        descMain: 'Validator',
        sub: [{
          type: 'required',
          descSub: 'Required',
          status: 'done'
        }, {
          type: 'dateFormat',
          descSub: 'Date Format DD/MM/YYYY',
          status: 'done'
        }, {
          type: 'largerThan',
          descSub: 'Date2 must large or equal to Date1',
          status: 'done'
        }, {
          type: 'requiredWhenExist',
          descSub: 'Date2 is required when Date1 exist',
          status: 'done'
        }, {
          type: 'requiredAny',
          descSub: 'TimeStrt or TimeEnd are required any',
          status: 'done'
        }, {
          type: 'requiredAllWhenExistAll',
          descSub: 'TimeStrt and TimeEnd are required when DateStrt and DateEnd are exist',
          status: 'done'
        }, {
          type: 'requiredAllWhenExistAny',
          descSub: 'TimeStrt and TimeEnd are required when DateStrt or DateEnd are exist',
          status: 'done'
        }, {
          type: 'requiredAllWhenNotExistAll',
          descSub: 'TimeStrt and TimeEnd are required when DateStrt and DateEnd are not exist',
          status: 'done'
        }, {
          type: 'requiredAllWhenNotExistAny',
          descSub: 'TimeStrt and TimeEnd are required when DateStrt or DateEnd are not exist',
          status: 'done'
        }, {
          type: 'requiredAnyWhenExistAll',
          descSub: 'TimeStrt or TimeEnd are required when DateStrt and DateEnd are exist',
          status: 'done'
        }, {
          type: 'requiredAnyWhenExistAny',
          descSub: 'TimeStrt or TimeEnd are required when DateStrt or DateEnd are exist',
          status: 'done'
        }, {
          type: 'requiredAnyWhenNotExistAll',
          descSub: 'TimeStrt or TimeEnd are required when DateStrt and DateEnd are not exist',
          status: 'done'
        }, {
          type: 'requiredAnyWhenNotExistAny',
          descSub: 'TimeStrt or TimeEnd are required when DateStrt or DateEnd are not exist',
          status: 'done'
        }, {
          type: 'validateAll',
          descSub: 'All rules',
          status: 'done'
        }]
      }, {
        main: 'pdf',
        descMain: 'PDF Report',
        sub: [{
          type: 'html',
          descSub: 'Export to PDF from HTML',
          status: 'coding'
        }, {
          type: 'text',
          descSub: 'Export to PDF from Text',
          status: 'coding'
        }, {
          type: 'password',
          descSub: 'Export to PDF with Password',
          status: 'coding'
        }]
      }, {
        main: 'export',
        descMain: 'Export File  ',
        sub: [{
          type: 'html',
          descSub: 'Export to HTML File',
          status: 'coding'
        }, {
          type: 'text',
          descSub: 'Export to Text File',
          status: 'coding'
        }, {
          type: 'excel',
          descSub: 'Export to Excel File',
          status: 'coding'
        }]
      }, {
        main: 'import',
        descMain: 'Import File  ',
        sub: [{
          type: 'csv',
          descSub: 'Import to CSV File',
          status: 'coding'
        }, {
          type: 'text',
          descSub: 'Import to Text File',
          status: 'coding'
        }, {
          type: 'excel',
          descSub: 'Import to Excel File',
          status: 'coding'
        }]
      }, {
        main: 'calendar',
        descMain: 'Calendar',
        sub: [{
          type: 'worktime',
          descSub: 'Work Time',
          status: 'done'
        }]
      }, {
        main: 'upload',
        descMain: 'File Uploader',
        sub: [{
          type: 'single',
          descSub: 'Single File',
          status: 'done'
        }, {
          type: 'multi',
          descSub: 'Multiple File',
          status: 'coding'
        }, {
          type: 'image',
          descSub: 'Only Image File (jpeg/gif/pdf)',
          status: 'done'
        }, {
          type: 'file',
          descSub: 'Only Document File (xlsx/pdf/doc)',
          status: 'done'
        }, {
          type: 'limit',
          descSub: 'Limit Size',
          status: 'coding'
        }]
      }, {
        main: 'logicalstatement',
        descMain: 'Logical Statement',
        sub: [{
          type: 'add',
          descSub: 'Add',
          status: 'coding'
        }]
      }, {
        main: 'orgchart',
        descMain: 'Organize Chart',
        sub: [{
          type: 'orgchartJs',
          descSub: 'Org Chart Javascript Version',
          status: 'coding'
        }]
      }, {
        main: 'chart',
        descMain: 'Chart',
        sub: [{
          type: 'line',
          descSub: 'Line',
          status: 'done'
        }, {
          type: 'bar',
          descSub: 'Bar',
          status: 'done'
        }, {
          type: 'pie',
          descSub: 'Pie',
          status: 'coding'
        }, {
          type: 'bubble',
          descSub: 'Bubble',
          status: 'coding'
        }, {
          type: 'radar',
          descSub: 'Radar',
          status: 'done'
        }]
      }]
    }
  },
  methods: {
    togglePage (topic, sub) {
      this.toggleMenu()
      this.toggle(topic, sub)
    },
    toggleMenu () {
      this.menuDisp = !this.menuDisp
    },
    toggle (topic, sub) {
      this.main = topic.main
      this.descMain = topic.descMain
      this.type = sub.type
      this.descSub = sub.descSub
    },
    topicFilter (topics, status) {
      return topics.filter(function (topic) {
        var found = false
        for (var sub of topic.sub) {
          if (sub.status === status) {
            found = true
          }
        }
        return found
      })
    },
    subFilter (subs, status) {
      return subs.filter(function (sub) {
        return sub.status === status
      })
    }
  },
  components: {
    demoTableSort,
    demoTableRequest,
    demoTableApproveAll,
    demoTableApproveRow,
    demoTableInlineAdd,
    demoTableInlineEdit,
    demoTableInlineDelete,
    demoTableInlineValidate,
    demoTableInline,
    demoTableDisplay,
    demoTableRowConditionRequest,
    demoTableRowConditionInline,
    demoTableRowConditionApprove,
    demoTableRowColumnStyle,
    demoSearchboxBoxType,
    demoSearchboxRules,
    demoSearchboxCondition,
    demoSearchboxCodcomp,
    demoSearchboxCodempid,
    demoSearchboxCodpos,
    demoSearchboxCodapp,
    demoValidateRequired,
    demoValidateDateFormat,
    demoValidateLargerThan,
    demoValidateRequiredWhenExist,
    demoValidateRequiredAny,
    demoValidateRequiredAllWhenExistAll,
    demoValidateRequiredAllWhenExistAny,
    demoValidateRequiredAllWhenNotExistAll,
    demoValidateRequiredAllWhenNotExistAny,
    demoValidateRequiredAnyWhenExistAll,
    demoValidateRequiredAnyWhenExistAny,
    demoValidateRequiredAnyWhenNotExistAll,
    demoValidateRequiredAnyWhenNotExistAny,
    demoValidateValidateAll,
    demoCalendarWorktime,
    demoUploadSingle,
    demoUploadImage,
    demoUploadFile,
    demoPdfReportHtml,
    demoPdfReportText,
    demoPdfReportPassword,
    demoExportHtml,
    demoExportText,
    demoExportExcel,
    demoImportCsv,
    demoImportText,
    demoImportExcel,
    demoLogicalStatement,
    demoOrgchartJs,
    demoChartLine,
    demoChartBar,
    demoChartPie,
    demoChartBubble,
    demoChartRadar
  }
}
</script>


// WEBPACK FOOTER //
// component.vue?2d7c8f0b